<template>
  <div>
    <el-dialog :title="$t('text.existingUsers')" :visible.sync="localShow" width="1100px" append-to-body>
      <page
          :url="url"
          :form="form"
          :isCustomization="true"
          @request-result="onResult"
          ref="pageRef"
      >
        <template slot="tableSearch">
          <el-form-item :label="$t('text.displayName')">
            <el-input
                v-model="form.name"
                clearable
                :placeholder="$t('message.inputName')"
                style="width: 180px"
                maxlength="50"
                @keyup.enter.native="searchByName"
            />
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button :loading="loading" type="primary" size="small" icon="el-icon-plus"
                     @click="showUserInfoInsertDialog">
            {{ $t('text.atUserIdAdd') }}
          </el-button>
        </template>

        <template slot="customization">
          <el-table :data="formTable" border stripe style="width: 100%">
            <el-table-column prop="name" :label="$t('text.displayName')" width="120" align="center" header-align="center"/>
            <el-table-column prop="role" :label="$t('text.role')" min-width="100" align="center" header-align="center"/>
            <el-table-column prop="userId" label="Lark ID" min-width="160" align="center" header-align="center" show-overflow-tooltip/>
            <el-table-column prop="tgUserId" :label="$t('text.tgUserId')" min-width="280" align="center" header-align="center">
              <template slot-scope="scope">
                <TgUserIdField
                    v-if="editingId === scope.row.id"
                    v-model="editingTgUserId"
                    size="mini"
                />
                <span v-else>{{ scope.row.tgUserId || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('text.actions')" width="180" align="center" header-align="center" fixed="right">
              <template slot-scope="scope">
                <div class="action-cell">
                  <template v-if="editingId !== scope.row.id">
                    <el-button type="primary" size="mini" plain @click="startEditTgUserId(scope.row)">
                      {{ $t('text.edit') }}
                    </el-button>
                  </template>
                  <template v-else>
                    <el-button type="success" size="mini" plain :loading="loading" @click="saveTgUserId(scope.row)">
                      {{ $t('text.confirm') }}
                    </el-button>
                    <el-button size="mini" plain @click="cancelEditTgUserId">{{ $t('text.cancel') }}</el-button>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </page>

      <div slot="footer">
        <el-button @click="localShow = false">{{ $t('text.close') }}</el-button>
      </div>
    </el-dialog>

    <MessagingAppAtUserInsert :show.sync="showUserInfoInsert"
                              :appUserInfo="appUserInfo"
                              :roleList="roleList"
                              @update-messaging-user-info="selectMessagingUserInfo"/>
  </div>
</template>

<script>
import MessagingAppAtUserInsert from "@/views/developer/components/messagingAppAt/MessagingAppAtUserInsert.vue";
import TgUserIdField from "@/views/developer/components/messagingAppAt/TgUserIdField.vue";
import page from "@/components/Page.vue";

export default {
  components: {page, MessagingAppAtUserInsert, TgUserIdField},
  props: {
    show: {type: Boolean, default: false},
    roleList: {type: Array, default: () => []},
    appUserInfo: {type: Array, default: () => []},
  },
  data() {
    return {
      url: "/messagingAppUserInfo/selectList",
      showUserInfoInsert: false,
      isFetching: false,
      loading: false,
      formTable: [],
      form: {
        name: ''
      },
      editingId: null,
      editingTgUserId: ''
    };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.cancelEditTgUserId();
          this.$nextTick(() => {
            if (this.$refs.pageRef) {
              if (typeof this.$refs.pageRef.onSubmit === 'function') {
                this.$refs.pageRef.onSubmit();
              }
            }
          });
        }
      }
    }
  },
  methods: {
    searchByName() {
      if (this.$refs.pageRef && typeof this.$refs.pageRef.onSubmit === 'function') {
        this.$refs.pageRef.onSubmit();
      }
    },
    selectMessagingUserInfo() {
      this.$emit('update-messaging-user-info');
    },
    showUserInfoInsertDialog() {
      this.showUserInfoInsert = true;
    },
    onResult(data) {
      if (data && Object.keys(data).length > 0) {
        this.formTable = data.list || [];
      } else {
        this.formTable = [];
      }
      this.loading = false;
    },
    startEditTgUserId(row) {
      this.editingId = row.id;
      this.editingTgUserId = row.tgUserId || '';
    },
    cancelEditTgUserId() {
      this.editingId = null;
      this.editingTgUserId = '';
    },
    saveTgUserId(row) {
      this.loading = true;
      this.$axios.put('/messagingAppUserInfo/editTgUserId', null, {
        params: {id: row.id, tgUserId: this.editingTgUserId}
      }).then(res => {
        if (res.code === 200) {
          this.$notify.success({title: this.$t('text.success'), message: res.msg});
          this.cancelEditTgUserId();
          this.$emit('update-messaging-user-info');
          if (this.$refs.pageRef) {
            this.$refs.pageRef.onSubmit();
          }
        } else {
          this.$notify.error({title: this.$t('text.error'), message: res.msg});
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.action-cell {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}
</style>
